module.exports = __webpack_public_path__ + "img/雷阵雨.e8b681b4.png";